import styled, { css } from "styled-components"
import { Atom } from 'AppReact';

const btnTemplate = styled.label`
  ${({ theme }) => css`
    border-radius: 50%;
    border: 1px solid #ccc;
    background: #FFF;
    padding: 5px 8px;
    box-shadow: inset #ccc 0px 0px 1px 0px;
    cursor: pointer;
    &:hover {
      border: 1px solid ${theme?.colour?.primary ?? '#1DBD6B'};
      background: #fbfbfb;
    }
  `}
`;

export default Atom({ type: 'upload', dataType: '', template: btnTemplate })